$(function(){
    $('#signupEmailOpenButton').click(function (e) {
        if(validEmail($("#emailSubscribe").val())){
            $.modal({
                open: "subscribe",
                triggerOpen: true
            });
        }
    })

    function validEmail(email)
    {
        var atPosition = email.indexOf("@");
        var dotPosition = email.lastIndexOf(".");
        if (atPosition<1 || dotPosition<atPosition+2 || dotPosition+2>=email.length)
        {
            alert("Not a valid e-mail address");
            return false;
        }
        return true;
    }

});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/footer/index.js